<template>

    <FloatingPanel title="Blog">

        <div class="canvas::blocks-modules-blog-BlockPanel">

            <Tabs :tabs="[
                'Maatwerk',
                'Algemeen',
            ]">

                <div slot="Maatwerk">

                    <SwitchInput
                        label="Titel of breadcrumbs"
                        instruction=""
                        :options="options"
                        options-property="title_or_breadcrumbs"
                        :items="[
                            { value: 'title', label: 'Titel'},
                            { value: 'breadcrumbs', label: 'Breadcrumbs'},
                        ]"
                        defaultValue="title"
                        :open="true"
                    />

                    <SwitchInput
                        label="Toon paginatie"
                        instruction="Bepaal hier of de paginatie moet worden getoond."
                        :options="options"
                        options-property="show_pagination"
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        defaultValue="0"
                    />

                    <TextInput
                        label="Paginatie aantal"
                        instruction="Bepaal hier het aantal items per pagina."
                        :options="options"
                        options-property="pagination_amount"
                        :open="false"
                    />

                    <SwitchInput
                        label="Slider op mobiel"
                        instruction="Bepaal hier of de blogs als slider getoond moeten worden op mobiel."
                        :options="options"
                        options-property="mobile_slider"
                        :items="[
                            { value: '1', label: 'Ja'},
                            { value: '0', label: 'Nee'},
                        ]"
                        defaultValue="1"
                    />

                </div>
                    

                <div slot="Algemeen">

                    <CommonInputs
                        :options="options"
                    />

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";
import AbstractPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel';
import FloatingPanel from '@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel';
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import TextInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/TextInput";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        Tabs,
        TextInput,
        SwitchInput,
    },

}

</script>
